import React from 'react';
import TeamsIcon from "../../../assets/icons/Microsoft_Teams.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import Linked from './Linked';
import FeatureLock from "../../../components/FeatureLock/FeatureLock";
import { FEATURE_IDS } from "../../../constants/featureAccess";
import { MICROSOFT_TEAMS_ID } from '../../../data/integration-app';

const MicrosoftTeams = ({connectedVenues}) => {
    return (
        <Col md="6" xxl="3" xl="4">
            <FeatureLock featureId={FEATURE_IDS.MICROSOFT_TEAMS}>
                <Link to="/integrations/ms-teams" className="int-col">
                {connectedVenues.some(data => parseInt(data.app_id) === MICROSOFT_TEAMS_ID) && <Linked />}
                <div className="img">
                    <img src={TeamsIcon} alt="Microsoft Teams" />
                </div>
                <div className="text">
                    <h3>Microsoft Teams</h3>
                    <p>
                        Collaborate and meet instantly with Microsoft Teams — chat, video, and files all in one place.
                    </p>
                </div>
                </Link>
            </FeatureLock>
        </Col>
    );
}

export default MicrosoftTeams;
